import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { FederatedHit } from '../algolia/components'

const FederatedResults = ({ hit, clickCallback }: { hit: FederatedHit, key: unknown, clickCallback: (hit: FederatedHit) => void }) => {
  return (
    <div onClick={() => clickCallback(hit)} className='qa-topic-block thread-list-item topic-view forum-list-view-spacing thread-list-item--federated'>
      <span className='thread-list-item--index-label'>
        <Phrase m='Forum' p='federated.search.federated' />
      </span>
      <h4 className='thread-list-block__title'>
        <a className='qa-topic-title thread-list-block__title-link' href={hit.url} target='_blank' rel='noreferrer'>{hit.title}</a>
      </h4>
      <p className='thread-list-block__content qa-topic-content'>
        <a href={hit.url} target='_blank' rel='noreferrer'>{hit.content}</a>
      </p>
    </div>
  )
}

export default FederatedResults
